export const BrokenNetworkConnectionIcon: React.FC<{ className?: string }> = ({ className }) => {
	return (
		<svg
			width="27"
			height="27"
			viewBox="0 0 27 27"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
			className={className}
		>
			<path
				d="M13.5 27C20.9558 27 27 20.9558 27 13.5C27 6.04416 20.9558 0 13.5 0C6.04416 0 0 6.04416 0 13.5C0 20.9558 6.04416 27 13.5 27Z"
				fill="#FF0000"
			/>
			<path
				d="M14.3668 11.2452C11.6758 11.0254 8.99823 11.8399 6.82805 13.4161L4.94268 11.1268C8.23515 8.53521 12.6519 7.66931 16.7345 8.59745L18.214 6.84264L19.2342 7.70313L8.4381 20.2601L7.44231 19.3759L9.67201 16.7343L7.93411 14.5918C9.40142 13.3816 11.2922 12.745 13.1904 12.6828C13.2621 12.6503 14.1497 11.643 14.2471 11.5091C14.3046 11.4299 14.379 11.3541 14.3655 11.2459L14.3668 11.2452Z"
				fill="white"
			/>
			<path
				d="M13.4291 21.1058L11.696 19.05V18.8173L13.0929 17.1903C13.5462 16.8244 15.6933 17.5252 16.0593 18.0819L13.4291 21.1058Z"
				fill="white"
			/>
			<path
				d="M16.5671 13.1982C17.4648 13.5385 18.3246 13.9924 19.0572 14.6188L17.1536 16.8796L15.9332 16.1646L14.4267 15.6748L16.5684 13.1975L16.5671 13.1982Z"
				fill="white"
			/>
			<path
				d="M19.5428 9.66879C19.7511 9.5477 21.7887 10.8946 22.0566 11.1571L20.0914 13.4064C19.3392 12.7962 18.4597 12.3998 17.5972 11.979L19.5428 9.66879Z"
				fill="white"
			/>
		</svg>
	);
};
